import { combineReducers } from 'redux';
import { SettingsReducer, initialSettingsState } from './settings';
import { VideoReducer } from './video';
import { ContentReducer } from './content';
import { SessionReducer, initialSessionState } from './session';
import { InvitationsReducer, initialInvitationsState } from './invitations';
import { ChatReducer } from './chat';
import { MediaReducer, initialMediaState } from './media';
import { ModalReducer } from './modal';
import { MeetingReducer, initialMeetingState } from './meeting';
import { NotificationsReducer } from './notifications';
import { NotesReducer } from './notes';
import { initialOpenTokState, OpenTokReducer } from './opentok';
import { BroadcastReducer, initialBroadcastingState } from './broadcasting';
import { HomeReducer, HOME_ROUTES } from './home';
import { ShotsReducer, initialShotsState } from './shots';
import { SegmentsReducer, initialSegmentsState } from './segments';
import { GraphicsReducer, initialGraphicsState } from './graphics';
import { UserInterfaceReducer } from './user-interface';
import { TeleprompterReducer } from './teleprompters';
import { SHOW_DETAILS_BACK } from '../actions/main';
import { DebugReducer, initialDebugState } from './debug';
import { CommToggleReducer } from './comm-toggle';
import { GeneratedContentReducer, initialGeneratedContentState } from './generate-content';
import FeatureFlagsReducer from './blp-feature-flags';
import { TabsReducer, initialTabsState } from './tabs';
import { MasksReducer } from './masks';
import { ContentChipsReducer, initialContentChipsState } from './content-chips';
import { ThemesReducer, intialThemesState } from './themes';
import { FontAssetsReducer, initialFontAssetsState } from './font-assets';
import { LivekitReducer, initialLivekitState } from './livekit';
import { DopReducer, initialDopState } from './dop';

function lastAction(state: any = null, action: any = null) {
	return action;
}

const appReducers = combineReducers({
	SettingsReducer,
	VideoReducer,
	ContentReducer,
	SessionReducer,
	InvitationsReducer,
	ChatReducer,
	NotificationsReducer,
	NotesReducer,
	MediaReducer,
	MeetingReducer,
	ModalReducer,
	OpenTokReducer,
	BroadcastReducer,
	lastAction,
	HomeReducer,
	ShotsReducer,
	SegmentsReducer,
	UserInterfaceReducer,
	TeleprompterReducer,
	GraphicsReducer,
	DebugReducer,
	CommToggleReducer,
	GeneratedContentReducer,
	FeatureFlagsReducer,
	TabsReducer,
	MasksReducer,
	ContentChipsReducer,
	ThemesReducer,
	FontAssetsReducer,
	LivekitReducer,
	DopReducer,
});

export const baseStateForHomeView = (state: any) => ({
	...state,
	SettingsReducer: {
		...initialSettingsState,
		featureFlags: state.SettingsReducer.featureFlags,
	},
	InvitationsReducer: initialInvitationsState,
	MediaReducer: initialMediaState,
	MeetingReducer: initialMeetingState,
	BroadcastReducer: initialBroadcastingState,
	OpenTokReducer: initialOpenTokState,
	ShotsReducer: initialShotsState,
	SegmentsReducer: initialSegmentsState,
	HomeReducer: {
		...state.HomeReducer,
		currentRoute: HOME_ROUTES.SHOWS,
	},
	SessionReducer: {
		...state.SessionReducer,
		showSessionTypes: initialSessionState.showSessionTypes,
		showSessions: initialSessionState.showSessions,
		showSessionsLoading: initialSessionState.showSessionsLoading,
	},
	GraphicsReducer: initialGraphicsState,
	DebugReducer: initialDebugState,
	GeneratedContentReducer: initialGeneratedContentState,
	FeatureFlagsReducer: state.FeatureFlagsReducer,
	TabsReducer: initialTabsState,
	ContentChipsReducer: initialContentChipsState,
	ThemesReducer: intialThemesState,
	FontAssetsReducer: initialFontAssetsState,
	LivekitReducer: initialLivekitState,
	DopReducer: initialDopState,
});

const rootReducer = (state: any, action: any) => {
	// When a user returns to the home view from show details, we want to clear meeting-specific data.
	// This action is used to reset multiple reducers back to their initial state.
	if (action.type === SHOW_DETAILS_BACK) {
		return appReducers(baseStateForHomeView(state), action);
	}

	// when we use mainStore into our tests (which uses this rootReducer) -
	// we have to reset the reducers between tests
	if (action.type === 'RESET_REDUCERS_TO_INIT') {
		return appReducers(undefined, action);
	}

	return appReducers(state, action);
};

export default rootReducer;
